/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The OnboardingTodoState model module.
 * @module model/OnboardingTodoState
 * @version V1
 */
class OnboardingTodoState {
    /**
     * Constructs a new <code>OnboardingTodoState</code>.
     * @alias module:model/OnboardingTodoState
     */
    constructor() { 
        
        OnboardingTodoState.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>OnboardingTodoState</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OnboardingTodoState} obj Optional instance to populate.
     * @return {module:model/OnboardingTodoState} The populated <code>OnboardingTodoState</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OnboardingTodoState();

            if (data.hasOwnProperty('hasCreatedProof')) {
                obj['hasCreatedProof'] = ApiClient.convertToType(data['hasCreatedProof'], 'Boolean');
            }
            if (data.hasOwnProperty('hasReviewLinkRegistered')) {
                obj['hasReviewLinkRegistered'] = ApiClient.convertToType(data['hasReviewLinkRegistered'], 'Boolean');
            }
            if (data.hasOwnProperty('hasEmailTemplateCreated')) {
                obj['hasEmailTemplateCreated'] = ApiClient.convertToType(data['hasEmailTemplateCreated'], 'Boolean');
            }
            if (data.hasOwnProperty('hasUsedWorkflow')) {
                obj['hasUsedWorkflow'] = ApiClient.convertToType(data['hasUsedWorkflow'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>OnboardingTodoState</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>OnboardingTodoState</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Boolean} hasCreatedProof
 */
OnboardingTodoState.prototype['hasCreatedProof'] = undefined;

/**
 * @member {Boolean} hasReviewLinkRegistered
 */
OnboardingTodoState.prototype['hasReviewLinkRegistered'] = undefined;

/**
 * @member {Boolean} hasEmailTemplateCreated
 */
OnboardingTodoState.prototype['hasEmailTemplateCreated'] = undefined;

/**
 * @member {Boolean} hasUsedWorkflow
 */
OnboardingTodoState.prototype['hasUsedWorkflow'] = undefined;






export default OnboardingTodoState;

